import React, { useState } from "react";
import Loginlogo from '../../Common/Loginlogo';
import { useDispatch } from "react-redux";
import { VerifyOtp } from "../../../Redux/action/AuthAction";
import { ToastContainer, toast } from 'react-toastify';
import $ from "jquery";
import { Link } from "react-router-dom";
import ebenchLogo from "../../../images/ebench_logo.png"
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';

const OtpVerifyTemp = () => {
    const dispatch = useDispatch();

    const [state, setState] = useState({
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: "",
    });

    const { otp1, otp2, otp3, otp4, otp5, otp6 } = state;
    const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
    };

    const email = localStorage.getItem("email");
    const data = {
        otp,
        email
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (data?.otp == "") {
            toast.error("Please enter your otp!");
        } else {
            dispatch(VerifyOtp(data));
        }
    };

    $('.digit-group').find('input').each(function () {
        $(this).attr('maxlength', 1);
        $(this).on('keyup', function (e) {
            var parent = $($(this).parent());

            if (e.keyCode === 8 || e.keyCode === 37) {
                var prev = parent.find('input#' + $(this).data('previous'));

                if (prev.length) {
                    $(prev).select();
                }
            } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                var next = parent.find('input#' + $(this).data('next'));
                if (next.length) {
                    $(next).select();
                } else {
                    if (parent.data('autosubmit')) {
                        parent.submit();
                    }
                }
            }
        });
    });

    return (
        <> 
        <ToastContainer />
        <header className={`d-flex justify-content-between align-items-center px-5`}>
                    <div className="landing_logo">
                        <Link to={'/'}>
                        <img src={ebenchLogo} alt="" className="responsive-logo-of-without-login" />
                        </Link>
                    </div>

                    <div className="landing_menu_items d-flex align-items-center gap-3">
                        <Link to='/login'>
                            <div className="landing_menu ld_login1 ms-1 mb-0" style={{ border: 'none', color: '#286a94' }}><></></div>
                        </Link>
                    </div>
                </header>
        
                    <div style={{minWidth:"100%",height:"100vh" , display:"flex", alignItems:"center", justifyContent:"center"}} >
                   

                        <div style={{ backgroundColor:"white",borderRadius:"10px",boxShadow:"2px 2px 19px rgba(0, 0, 0, 0.2)" , height:"50%", padding:'40px 30px',}}>
                            <h4 style={{marginBottom:"50px"}} className="text_center">Enter Verification OTP</h4>
                            <form onSubmit={handleSubmit} className="d-flex align-items-center flex-column">
                            <div class="">
                            <p style={{marginBottom:"10px"}}>Type your 6 digit security code</p>
                                <div class=" digit-group">
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp1" id="digit-1" data-next="digit-2" value={otp1} onChange={handleInputChange} />
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp2" id="digit-2" data-next="digit-3" data-previous="digit-1" value={otp2} onChange={handleInputChange} />
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp3" id="digit-3" data-next="digit-4" data-previous="digit-2" value={otp3} onChange={handleInputChange} />
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp4" id="digit-4" data-next="digit-5" data-previous="digit-3" value={otp4} onChange={handleInputChange} />
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp5" id="digit-5" data-next="digit-6" data-previous="digit-4" value={otp5} onChange={handleInputChange} />
                                    <input autoComplete="off" style={{fontSize:"30px"}} type="text" class="otp-box" name="otp6" id="digit-6" data-previous="digit-5" value={otp6} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="form-group mt-4 reg verify_button">
                            <Button type="submit" style={{ padding: "10px 27px", background: "#286a94", marginTop: "12px" }} variant="contained">
                                    Submit
                                </Button>
                            </div>
                            <div>
                                <p style={{margin:"10px"}}>Did'nt get the code? Resend</p>
                            </div>
                        </form>
                    </div>
                </div>
           
    </>
    )
}

export default OtpVerifyTemp